import { Component, HostBinding, Input } from '@angular/core';
import { convertNumber } from '../../all.helpers';
import { CommonModule } from '@angular/common';
import { GenericCardComponent } from '../generic-card/generic-card.component';

export interface StatInput {
    prefix?: string;
    value: string | number | undefined;
    suffix?: string;
    precision?: number;
    style?: 'success' | 'danger' | 'info';
}

@Component({
    selector: 'kpi-card',
    templateUrl: './kpi-card.component.html',
    styleUrls: ['./kpi-card.component.scss'],
    standalone: true,
    imports: [CommonModule, GenericCardComponent],
})
export class KpiCardComponent {
    @Input() title: string | undefined;
    @Input() set body(value: StatInput | undefined) {
        this.bodyValue = this._formatValue(value, false);
    }
    @Input() set badge(value: StatInput | undefined) {
        this.badgeValue = this._formatValue(value, true);
        this.badgeStyle = value?.style || '';
    }
    @Input() set footer(value: StatInput | undefined) {
        this.footerValue = this._formatValue(value, false);
    }
    @Input() descriptionTitle?: string;
    @Input() descriptionContent?: string;
    @Input() error: boolean = false;
    @Input() isLoading: boolean = true;
    @Input() cardClass: string = '';

    // Bind the cardClass property to the class attribute of the host element
    @HostBinding('class') get hostClasses(): string {
        return this.cardClass;
    }

    public bodyValue: string = '';
    public badgeValue: string = '';
    public badgeStyle: string = '';
    public footerValue: string = '';

    constructor() {}

    private _formatValue(stat: StatInput | undefined, addPlusSign: boolean = false): string {
        if (!stat) {
            return '';
        }

        const stringValue =
            typeof stat.value === 'number'
                ? convertNumber(stat.value, stat.precision, addPlusSign)
                : stat.value || '';
        return `${stat.prefix || ''}${stringValue}${stat.suffix || ''}`;
    }
}
